export enum TabNames {
  PANORAMICA = 'PANORAMICA',
  STATISTICHE = 'STATISTICHE',
  DOCUMENTI = 'DOCUMENTI',
  CONVERSAZIONI = 'CONVERSAZIONI',
  IMPOSTAZIONI = 'IMPOSTAZIONI',
  PERMESSI = 'PERMESSI',
}